const digiSlider = {
    _headerSlider: null,
    _cardSliders: [],
    _heroSliders: [],

    init() {

        if((document.querySelectorAll('.js-header-slider').length === 0) && (document.querySelectorAll('.js-card-slider').length === 0) && (document.querySelectorAll('.js-hero-slider').length === 0)) {
            return;
        }

        let self = this;
        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        const cssUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

        window.App.InitPackages([scriptUrl, cssUrl]).then(() => {
            self._constructSlider();
        }).catch((error) => {
            console.error(error);
        });

    },
    _constructSlider() {
        let self = this;
        let headerSlider = document.querySelector('.js-header-slider');
        let cardSliders = document.querySelectorAll('.js-card-slider');
        let heroSliders = document.querySelectorAll('.js-hero-slider');

        if(headerSlider) {
            self._headerSlider = new Swiper('.js-header-slider', {
                grabCursor: true,
                loop: true,
                autoplay: {
                    delay: 8000,
                    pauseOnMouseEnter: true,
                },
                effect: "creative",
                creativeEffect: {
                    prev: {
                      shadow: true,
                      translate: ["-20%", 0, -1],
                    },
                    next: {
                      translate: ["100%", 0, 0],
                    },
                },
            });
        }

        if(cardSliders.length > 0) {
            cardSliders.forEach((cardSlider, index) => {
                self._cardSliders[index] = new Swiper('.js-card-slider', {
                    spaceBetween: 24,
                    loop: false,
                    effect: 'slide',
                    autoplay: false,
                    rewind: true,
                    slidesPerView: 2,
                    breakpoints:{
                        992: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                        }
                    },
                })
            });
        }

        if(heroSliders.length > 0) {
            heroSliders.forEach((heroSlider, index) => {
                self._heroSliders[index] = new Swiper(heroSlider, {
                    loop: true,
                    spaceBetween: 24,
                    autoplay: {
                        delay: 8000,
                        pauseOnMouseEnter: true,
                    },
                    rewind: false,
                    slidesPerView: 1,

                    pagination: {
                        el: heroSlider.parentElement.querySelector('.js-hero-slider__pagination'),
                        clickable: true,
                    },
                    lazyPreloadPrevNext: 0,
                    navigation: {
                        nextEl: heroSlider.parentElement.querySelector('.js-hero-slider__next'),
                        prevEl: heroSlider.parentElement.querySelector('.js-hero-slider__prev'),
                    },
                })
            });
        }
    },

    reInit() {
        let self = this;
        if(self._headerSlider) {
            self._headerSlider.destroy();
            self._headerSlider = null;
        }

        if(self._cardSliders && self._cardSliders.length > 0) {
            self._cardSliders.forEach((cardSlider, index) => {
                self._cardSliders[index].destroy();
            });

            self._cardSliders = [];
        }

        if(self._heroSliders && self._heroSliders.length > 0) {
            self._heroSliders.forEach((heroSlider, index) => {
                self._heroSliders[index].destroy();
            });

            self._heroSliders = [];
        }

        self.init();
    },
}

digiSlider.init();
document.addEventListener('LokiRequestEnd', function () {
    digiSlider.reInit();
});